import {
  Image,
  TouchableOpacity,
  ImageBackground,
  StyleSheet,
  ActivityIndicator,
  View,
  Text,
  Platform,
} from "react-native";

import Centered from "../../../../shared/Centered";
import {
  BGCollectBtn,
  BGCollectBtnWrapper,
  BGHorDivider,
} from "../../../../assets";
import { useDispatch } from "react-redux";
import { collectBonusRequest } from "../../../../store/bonus/bonusActions";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface IProps {
  isSmall?: boolean;
  isCollecting?: boolean;
}

function BGCollectButton({ isSmall, isCollecting = false }: IProps) {
  const dispatch = useDispatch();
  const isWeb = Platform.OS === "web";
  const { t } = useTranslation();

  const handleCollect = () => {
    if (isCollecting) return;
    dispatch(collectBonusRequest());
  };
  return (
    <View
      style={{
        alignItems: "center",
        justifyContent: "center",
        width: isSmall ? "90%" : 150,
        marginHorizontal: "auto",
      }}
    >
      {/* <ImageBackground
        source={BGCollectBtnWrapper}
        style={{
          // width: isSmall ? 150 : 167,
          aspectRatio: isSmall ? undefined : 1.56,
          height: isSmall ? 60 : undefined,
          position: "relative",
          alignItems: "center",
          justifyContent: "center",
          width: "90%",
          marginHorizontal: "auto",
          marginBottom: isWeb ? 6 : undefined,
        }}
      >
        <Centered
          style={{
            position: "absolute",
            top: isSmall ? 0 : 18,
            left: 0,
            right: 0,
            height: isWeb ? 20 : 1,
          }}
        > */}
      <Image
        source={BGHorDivider}
        resizeMode="contain"
        style={{
          width: "100%",
          aspectRatio: 27.5,
          maxWidth: isSmall ? 180 : undefined,
          marginBottom: isSmall ? -6 : 0,
        }}
      />
      <View
        style={{
          alignItems: "center",
          justifyContent: "center",
          marginVertical: 1,
        }}
      >
        <Text
          style={{
            color: "#fff",
            fontWeight: "bold",
            fontSize: isSmall ? 14 : 16,
            fontFamily: Platform.OS === "ios" ? "Arial" : "sans-serif",
            textTransform: "uppercase",
            textShadowColor: "rgba(0, 0, 0, 0.98)",
            textShadowOffset: { width: 0, height: 3 },
            textShadowRadius: 4,
            letterSpacing: 0.6,
            textAlign: "center",
          }}
        >
          {t("T_SITE_BONUSES_HEADING")}
        </Text>
      </View>
      <Image
        source={BGHorDivider}
        resizeMode="contain"
        style={{
          width: "100%",
          aspectRatio: 22,
          maxWidth: isSmall ? 180 : undefined,
          marginTop: isSmall ? -6 : 0,
        }}
      />
      <TouchableOpacity
        onPress={() => dispatch(collectBonusRequest())}
        activeOpacity={0.7}
        style={{
          width: isSmall ? "80%" : "90%",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <View style={{ alignItems: "center", justifyContent: "center" }}>
          <ImageBackground
            source={BGCollectBtn}
            style={{
              width: isSmall ? 100 : 100,
              height: isSmall ? 26 : undefined,
              aspectRatio: isSmall ? undefined : 3.4,
              marginTop: isSmall ? 0 : 6,
              marginBottom: isSmall ? 0 : 6,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Text
              style={{
                color: "#fff",
                fontWeight: "bold",
                fontSize: isSmall ? 12 : 14,
                fontFamily: Platform.OS === "ios" ? "Arial" : "sans-serif",
                textTransform: "uppercase",
                textShadowColor: "rgba(0, 0, 0, 0.98)",
                textShadowOffset: { width: 0, height: 3 },
                textShadowRadius: 4,
                letterSpacing: 0.6,
              }}
            >
              {t("T_RB_Collect")}
            </Text>
          </ImageBackground>
        </View>
      </TouchableOpacity>
      <Image
        source={BGHorDivider}
        resizeMode="contain"
        style={{
          width: "100%",
          aspectRatio: 27.5,
          maxWidth: isSmall ? 180 : undefined,
          marginTop: isSmall ? -4 : 0,
        }}
      />
      {/* </Centered>
      </ImageBackground> */}
    </View>
  );
}

export default BGCollectButton;
